















import { Component, Vue } from "vue-property-decorator";
import NotificationRequestNotificationList from "@/components/admin/notification/RequestNotificationList.vue";
import EditNotificationRequest from "@/components/admin/notification/EditNotificationRequest.vue";
import SideNotification from "@/components/admin/notification/SideNotification.vue";

@Component({
    components: {
        NotificationRequest: NotificationRequestNotificationList,
        EditNotificationRequest,
        SideNotification,
    },
})
export default class RequestNotificationPage extends Vue {
    private isCreating = false;
    private notification: Notification | null = null;

    private edit(notification: Notification): void {
        this.isCreating = true;
        this.notification = notification;
    }

    private cancel(): void {
        this.isCreating = false;
        this.notification = null;
    }
}
